import { makeStyles } from '@rbx/ui';

const useParameterReturnTableStyles = makeStyles()(() => ({
  title: {
    marginBottom: 8,
  },
}));

export default useParameterReturnTableStyles;
